export const CONTACT_US_URL = '/contact-us';
export const RETAIL_URL = '/compare-energy-rates';
export const LIGHTING_RETROFIT_URL = '/lighting-retrofit';
export const EV_CHARGING_URL = '/evcharging';
export const BATTERY_URL = 'services/battery-storage';
export const REBATES_URL = '/evcharging/rebates-for-our-ev-partners';
